import { instance, errorService } from '@/services/api'
import { dropdownAPIs, projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { convertFilterDate } from '@/services/convert'
import { formatKeys, socketEvents } from '@/services/config'
import { showNotification } from '@/services/calculate'
import moment from 'moment-timezone'

export default {
  props: ['isActive', 'component'],
  data() {
    return {
      filterForm: {
        clientId: undefined,
        projectNumber: undefined,
        projectName: undefined,
        projectStaffEngineer: undefined,
        projectManager: undefined,
        projectReviewer: undefined,
        city: undefined,
        state: undefined,
        fromCreatedDate: undefined,
        toCreatedDate: undefined,
        fromUpdatedDate: undefined,
        toUpdatedDate: undefined,
        entityName: undefined,
        percentComplete: undefined,
        viewAll: false,
      },
      close: false,
      dropdown: {
        managers: [],
        reviewers: [],
        staffs: [],
        states: [],
        cities: [],
        clients: [],
        projectNumbers: [],
        projectNames: [],
        percentCompletes: [],
      },
      tempList: {
        clients: [],
        projectNumbers: [],
        projectNames: [],
      },
      loadProjectNo: false,
      loadProjectName: false,
      dateFormat: 'DD/MM/YYYY',
      projectId: undefined,
      title: 'Viewing My Projects',
      count: 0,
    }
  },
  beforeMount() {
    this.onCheckFilter()
    this.getUserRoles()
    this.getStates()
    this.getCities()
    this.getPercentCompletes()
  },
  mounted() {
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.$root.$off('projectCount')
    this.$root.$on('projectCount', this.projectCount)
  },
  methods: {
    addNewProject() {
      this.$emit(
        'showLoader',
        true,
        'Please wait while copy application master data into project master...',
      )
      instance
        .post(projectAPIs.project.add)
        .then(res => {
          this.projectId = undefined
          const data = _.get(res.data, 'result', {})
          if (data.id) {
            this.projectId = data.id
          }
        })
        .catch(err => {
          errorService(err)
          this.$emit('showLoader', false, null)
        })
    },

    searchList() {
      const filter = { ...this.filterForm }
      if (this.filterForm.fromCreatedDate && this.filterForm.toCreatedDate) {
        let fromData =
          moment(this.filterForm.fromCreatedDate).format('YYYY-MM-DD') +
          ' 00:00:00'
        fromData = moment(fromData)
        filter.fromCreatedDate = convertFilterDate(fromData)
        let toDate =
          moment(this.filterForm.toCreatedDate).format('YYYY-MM-DD') +
          ' 23:59:59'
        toDate = moment(toDate)
        filter.toCreatedDate = convertFilterDate(toDate)
      }
      if (this.filterForm.fromUpdatedDate && this.filterForm.toUpdatedDate) {
        let fromDate2 =
          moment(this.filterForm.fromUpdatedDate).format('YYYY-MM-DD') +
          ' 00:00:00'
        fromDate2 = moment(fromDate2)
        filter.fromUpdatedDate = convertFilterDate(fromDate2)
        let toDate2 =
          moment(this.filterForm.toUpdatedDate).format('YYYY-MM-DD') +
          ' 23:59:59'
        toDate2 = moment(toDate2)
        filter.toUpdatedDate = convertFilterDate(toDate2)
      }
      if (
        this.filterForm.percentComplete &&
        this.filterForm.percentComplete.length > 0
      ) {
        filter.percentComplete = filter.percentComplete.join(',')
      } else {
        filter.percentComplete = undefined
      }
      this.$root.$emit('filterProject', filter)
      sessionStorage.removeItem('projectFilter')
      sessionStorage.setItem('projectFilter', JSON.stringify(filter))
    },

    clearFilter() {
      this.filterForm = {
        clientId: undefined,
        projectNumber: undefined,
        projectName: undefined,
        projectStaffEngineer: undefined,
        projectManager: undefined,
        projectReviewer: undefined,
        city: undefined,
        state: undefined,
        fromCreatedDate: undefined,
        toCreatedDate: undefined,
        fromUpdatedDate: undefined,
        toUpdatedDate: undefined,
        entityName: undefined,
        percentComplete: undefined,
        viewAll: false,
      }
      this.dropdown.clients = []
      this.dropdown.projectNumbers = []
      this.dropdown.projectNames = []
      this.tempList.projectNumbers = []
      this.tempList.projectNames = []
      this.$root.$emit('filterProject', this.filterForm)
      sessionStorage.removeItem('projectFilter')
    },

    onChange() {
      this.close = !this.close
      this.$root.$emit('onChange', this.close)
    },

    getUserRoles() {
      instance
        .post(dropdownAPIs.userRoles, [2, 4, 7])
        .then(response => {
          const data = _.get(response.data, 'result', [])
          this.dropdown.managers = data.find(i => i.role_Id === 2).users
          this.dropdown.reviewers = data.find(i => i.role_Id === 4).users
          this.dropdown.staffs = data.find(i => i.role_Id === 7).users
        })
        .catch(error => {
          errorService(error)
        })
    },

    getStates() {
      instance
        .get(dropdownAPIs.states)
        .then(response => {
          this.dropdown.states = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getCities() {
      instance
        .get(dropdownAPIs.cities)
        .then(response => {
          this.dropdown.cities = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getPercentCompletes() {
      instance
        .get(dropdownAPIs.percentCompletes)
        .then(response => {
          this.dropdown.percentCompletes = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    onFromDateChange(dates, dateStrings) {
      if (dates.length > 0) {
        this.filterForm.fromCreatedDate = dates[0]
        this.filterForm.toCreatedDate = dates[1]
      } else {
        this.filterForm.fromCreatedDate = undefined
        this.filterForm.toCreatedDate = undefined
        this.searchList()
      }
    },

    // Disable Dates into Range
    disabledDate(current) {
      return current && current > moment(new Date(), 'YYYY-MM-DD')
    },

    onToDateChange(dates, dateStrings) {
      if (dates.length > 0) {
        this.filterForm.fromUpdatedDate = dates[0]
        this.filterForm.toUpdatedDate = dates[1]
      } else {
        this.filterForm.fromUpdatedDate = undefined
        this.filterForm.toUpdatedDate = undefined
        this.searchList()
      }
    },

    onSearch(searchText, type) {
      switch (type) {
        case 'Client':
          this.dropdown.clients = !searchText
            ? []
            : this.filterArray(searchText, 'clients')
          break
        case 'Project #':
          this.dropdown.projectNumbers = !searchText
            ? []
            : this.filterArray(searchText, 'projectNumbers')
          break
        case 'Project Name':
          this.dropdown.projectNames = !searchText
            ? []
            : this.filterArray(searchText, 'projectNames')
          break
      }
    },

    filterArray(searchText, field) {
      const list = []
      this.tempList[field].forEach(element => {
        if (
          element.option
            .toString()
            .toUpperCase()
            .indexOf(searchText.toUpperCase()) > -1
        ) {
          list.push(String(element.option))
        }
      })
      return list
    },

    filterProjects(value) {
      if (value && value.trim()) {
        this.searchList()
      }
    },

    onViewAllChange(value) {
      this.filterForm.viewAll = value
    },

    onCheckFilter() {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      this.dateFormat = settings.datetime.dateFormat
      let filter = sessionStorage.getItem('projectFilter')
      if (filter && this.isActive) {
        filter = JSON.parse(filter)
        this.filterForm = formatKeys(filter, this.filterForm)
      }
    },

    projectCount(count, title) {
      this.count = count
      this.title = title
    },

    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.copyApplicationMasterData) {
        this.$emit('showLoader', false, null)
        if (data.Status === 'SUCCESS') {
          this.$router.push(`dashboard/project/${this.projectId}`)
        } else {
          showNotification(
            'error',
            'Socket',
            _.get(data, 'Result.Message', null),
          )
        }
      }
    },
  },
}
